module.exports = __webpack_public_path__ + "static/media/Niveau_elN9_3_627199.e972f2ed.png";